import { QueryParams } from "@/models/query-params.model";
import { GeneralInfo } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { BehaviorSubject, Observable, take } from "rxjs";

export class GeneralService {
  constructor(private _stats = new StatsRest()) {}
  private general$: BehaviorSubject<any> = new BehaviorSubject<GeneralInfo>(
    new GeneralInfo()
  );
  general: Observable<GeneralInfo> = this.general$.asObservable();
  getGeneralFromCourse(courseId: string, params?: Partial<QueryParams>): void {
    this._stats
      .getGeneralFromCourse(courseId, params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.general$.next(response);
        },
      });
  }
}
